// PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const userName = localStorage.getItem('email');
  return userName ? children : <Navigate to="/" />;
};

export default PrivateRoute;
